/* @generated */

// ../src/combinations/label_group/label_group.tsx
import * as React from "react";
import cx from "classnames";
import { Text } from "@dropbox/dig-components/typography";
import {
  LabelGroup as NewLabelGroup
} from "@dropbox/dig-components/label_group";
import { atoms } from "@dropbox/dig-foundations";
var subtextSizeMapping = {
  small: "xsmall",
  medium: "small",
  large: "standard"
};
var labelGroupScrimGapMapping = (direction, size) => {
  let labelGap = "2";
  if (direction === "vertical" && size === "large") {
    labelGap = "4";
  } else if (direction === "horizontal") {
    labelGap = "8";
  }
  return labelGap;
};
var displayFlexClass = atoms({ display: "flex" });
var LabelGroup = ({
  align = "center",
  direction = "vertical",
  withText,
  withSubtext,
  htmlFor,
  withLeftAccessory,
  tagName: TagName = "div",
  size = "medium"
}) => {
  const leftAccessoryCls = cx(
    "dig-LabelGroup-leftAccessory",
    `dig-LabelGroup-leftAccessory--align-${align}`
  );
  const contentCls = cx(
    "dig-LabelGroup-content",
    `dig-LabelGroup-content--direction-${direction}`,
    `dig-LabelGroup-content--size-${size}`
  );
  const subtextSize = subtextSizeMapping[size];
  const labelGap = labelGroupScrimGapMapping(direction, size);
  return /* @__PURE__ */ React.createElement(
    NewLabelGroup,
    {
      accessoryGap: "8",
      labelGap,
      verticalAlignment: align,
      className: cx("dig-LabelGroup"),
      tagName: TagName,
      htmlFor,
      direction,
      _contentClassName: contentCls,
      withLabel: /* @__PURE__ */ React.createElement(Text, { size, variant: "label", color: "standard", className: cx("dig-LabelGroup-text") }, withText),
      withSubText: withSubtext && /* @__PURE__ */ React.createElement(
        Text,
        {
          variant: "label",
          color: "subtle",
          size: subtextSize === "standard" ? "medium" : subtextSize,
          className: "dig-LabelGroup-subtext"
        },
        withSubtext
      ),
      withStartAccessory: withLeftAccessory && /* @__PURE__ */ React.createElement("div", { className: cx(leftAccessoryCls, displayFlexClass) }, withLeftAccessory)
    }
  );
};
LabelGroup.displayName = "LabelGroup";

// ../src/combinations/button_group/button_group.tsx
import * as React2 from "react";
import cx2 from "classnames";
import { Children } from "react";

// ../src/combinations/button_group/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var buttonGroupButtonRecipe = _7a468({ defaultClassName: "dig-z4isv76_21-7-0", variantClassNames: { transparent: { true: "dig-z4isv77_21-7-0", false: "dig-z4isv78_21-7-0" } }, defaultVariants: { transparent: false }, compoundVariants: [] });
var buttonGroupRecipe = _7a468({ defaultClassName: "dig-z4isv70_21-7-0", variantClassNames: { isFullWidth: { true: "dig-z4isv71_21-7-0" }, isVertical: { true: "dig-z4isv72_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var iconButtonGroupRecipe = _7a468({ defaultClassName: "dig-z4isv73_21-7-0", variantClassNames: { circular: { true: "dig-z4isv74_21-7-0", false: "dig-z4isv75_21-7-0" } }, defaultVariants: { circular: false }, compoundVariants: [] });

// ../src/combinations/button_group/button_group.tsx
var ButtonGroup = ({
  className,
  children,
  size,
  fullWidth = false,
  layout = "horizontal",
  reverse = false
}) => {
  const isFullWidth = size === "xlarge" || fullWidth || layout === "vertical";
  const getButtonProps = React2.useMemo(() => {
    return ({ variant }) => {
      const props = {
        variant,
        className: cx2(
          "dig-ButtonGroup-button",
          `dig-ButtonGroup-button--variant-${variant}`,
          buttonGroupButtonRecipe({ transparent: variant === "transparent" })
        ),
        fullWidth: isFullWidth,
        size
      };
      return props;
    };
  }, [isFullWidth, size]);
  const getGroupChildren = () => {
    const renderedChildren = children ? children({ getButtonProps }) : null;
    if (reverse && React2.isValidElement(renderedChildren) && renderedChildren.props.children) {
      return React2.cloneElement(
        renderedChildren,
        {},
        Children.toArray(renderedChildren.props.children).reverse()
      );
    }
    return renderedChildren;
  };
  return /* @__PURE__ */ React2.createElement(
    "div",
    {
      className: cx2(
        className,
        buttonGroupRecipe({ isFullWidth, isVertical: layout === "vertical" }),
        "dig-ButtonGroup",
        `dig-ButtonGroup--${layout === "vertical" ? "isVertical" : "isHorizontal"}`,
        { "dig-ButtonGroup--isFullWidth": isFullWidth }
      )
    },
    getGroupChildren()
  );
};
ButtonGroup.displayName = "ButtonGroup";

// ../src/combinations/button_group/icon_button_group.tsx
import * as React3 from "react";
import cx3 from "classnames";
var IconButtonGroup = ({ className, size, children }) => {
  const getButtonProps = React3.useMemo(() => {
    return ({ isRounded, shape } = {}) => {
      const props = {
        isRounded,
        shape,
        className: cx3(
          "dig-ButtonGroup-iconButton",
          {
            "dig-ButtonGroup-iconButton--circular": isRounded === true || shape === "circular"
          },
          iconButtonGroupRecipe({ circular: isRounded === true || shape === "circular" })
        ),
        size
      };
      return props;
    };
  }, [size]);
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      className: cx3(
        "dig-ButtonGroup",
        "dig-IconButtonGroup",
        buttonGroupRecipe({ isFullWidth: false, isVertical: false }),
        className
      )
    },
    children && children({ getButtonProps })
  );
};
IconButtonGroup.displayName = "IconButtonGroup";
export {
  ButtonGroup,
  IconButtonGroup,
  LabelGroup
};
